// src/components/UserProfileCard.js
import React from "react";

function Row({ label, value }) {
  return (
    <div className="upc-row">
      <span className="upc-label">{label}</span>
      <span className="upc-value">{value || "—"}</span>
    </div>
  );
}

export default function UserProfileCard({
  firstName,
  lastName,
  email,
  roleDesignation,
  organization,
  creationDate,
  dsaAcceptedDate,
  onDownloadDsa,
}) {
  return (
    <aside className="user-profile-card" aria-label="User profile">
      <h4 className="upc-title">Your Profile</h4>
      <Row label="First name" value={firstName} />
      <Row label="Last name" value={lastName} />
      <Row label="Email" value={email} />
      <Row label="Role / Designation" value={roleDesignation} />
      <Row label="Organization" value={organization} />
      
      {creationDate && <Row label="Creation Date" value={creationDate} />}
      
      {dsaAcceptedDate && (
        <div className="upc-row">
          <span className="upc-label">DSA Accepted Date</span>
          <span className="upc-value">
            {dsaAcceptedDate}
            {" · "}
            <button
              onClick={onDownloadDsa}
              className="dsa-link-btn"
              style={{
                background: 'none',
                border: 'none',
                color: '#0066cc',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
                font: 'inherit',
                marginLeft: '4px'
              }}
            >
              Download DSA
            </button>
          </span>
        </div>
      )}
    </aside>
  );
}